<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<h1 id="toc-title">Enchanters: Royal Secrets</h1>
<ol class="toc">
<li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgement">Acknowledgement</a></li>
<li id="toc-li-5"><a href="#/text/ch005#chapter-1-entering-the-unknown">Chapter 1: Entering the Unknown</a>
</li>
<li id="toc-li-6"><a href="#/text/ch006#chapter-2-the-curse-of-eneas">Chapter 2: The Curse of Eneas</a></li>
<li id="toc-li-7"><a href="#/text/ch007#chapter-3-silverstring-academy-for-enchanters-and-enchantresses">Chapter 3: Silverstring
          Academy for Enchanters and Enchantresses</a></li>
<li id="toc-li-8"><span href="#/text/ch008#chapter-4-the-three-tribes-and-the-academy" title="Link target outside of Sample">Chapter 4: The Three Tribes
          and the Academy</span></li>
<li id="toc-li-9"><span href="#/text/ch009#chapter-5-silverstring-street-and-defensive-magic" title="Link target outside of Sample">Chapter 5:
          Silverstring Street and Defensive Magic</span></li>
<li id="toc-li-10"><span href="#/text/ch010#chapter-6-his-vulnerable-side-the-greatest-power-mark-and-maldeus" title="Link target outside of Sample">Chapter 6: His
          Vulnerable Side, the Greatest Power Mark, and Maldeus</span></li>
<li id="toc-li-11"><span href="#/text/ch011#chapter-7-the-date-aristera-and-the-encounter-with-real-defense" title="Link target outside of Sample">Chapter 7: The Date,
          Aristera, and the Encounter with Real Defense</span></li>
<li id="toc-li-12"><span href="#/text/ch012#chapter-8-andronicuss-day" title="Link target outside of Sample">Chapter 8: Andronicus’s Day</span></li>
<li id="toc-li-13"><span href="#/text/ch013#chapter-9-the-most-powerful-bond" title="Link target outside of Sample">Chapter 9: The Most Powerful
          Bond</span></li>
<li id="toc-li-14"><span href="#/text/ch014#chapter-10-the-man-behind-the-black-mask" title="Link target outside of Sample">Chapter 10: The Man behind
          the Black Mask</span></li>
<li id="toc-li-15"><span href="#/text/ch015#chapter-11-dark-encounter" title="Link target outside of Sample">Chapter 11: Dark Encounter</span></li>
<li id="toc-li-16"><span href="#/text/ch016#chapter-12-the-union-bond" title="Link target outside of Sample">Chapter 12: The Union Bond</span></li>
<li id="toc-li-17"><span href="#/text/ch017#chapter-13-the-end" title="Link target outside of Sample">Chapter 13: The End?</span></li>
<li id="toc-li-18"><span href="#/text/ch018#chapter-14-the-remaining-evil" title="Link target outside of Sample">Chapter 14: The Remaining Evil</span></li>
<li id="toc-li-19"><span href="#/text/ch019#chapter-15-the-afterlife" title="Link target outside of Sample">Chapter 15: The Afterlife</span></li>
<li id="toc-li-20"><span href="#/text/ch020#chapter-16-the-world-sees-the-mask-justice" title="Link target outside of Sample">Chapter 16: The World Sees
          the Mask, Justice</span></li>
<li id="toc-li-21"><span href="#/text/ch021#chapter-17-bran-beciles-secret" title="Link target outside of Sample">Chapter 17: Bran Becile’s Secret</span>
</li>
<li id="toc-li-22"><span href="#/text/ch022#chapter-18-the-pearl-of-echo" title="Link target outside of Sample">Chapter 18: The Pearl of Echo</span></li>
<li id="toc-li-23"><span href="#/text/ch023#chapter-19-what-is-happily-ever-after" title="Link target outside of Sample">Chapter 19: What Is Happily
          Ever After?</span></li>
<li id="toc-li-24"><span href="#/text/ch024#epilogue-one-month-later" title="Link target outside of Sample">Epilogue: One Month Later</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?c79cb514